import { Flex, Text, Button, Box } from "@chakra-ui/react";
import styles from "./KuriaMesh.module.css";
import Footer from "../components/Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const applicationSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  centerMode: true,
  centerPadding: "18%",
  responsive: [
    {
      breakpoint: 1220,
      settings: {
        centerPadding: "10%",
      },
    },
    {
      breakpoint: 768,
      settings: {
        centerPadding: "8%",
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerPadding: "5%",
      },
    },
  ],
};

const applicationCards = [
  {
    image: "/assets/kuriamesh/Aplikasi_1.png",
    alt: "Infrastructure",
    title: "INFRASTRUKTUR & TRANSPORTASI",
    desc: "Jalan Raya Beton | Perkerasan Kaku (Rigid Pavement) | Trotoar | Dan Lapisan Jembatan",
  },
  {
    image: "/assets/kuriamesh/Aplikasi_2.png",
    alt: "Industry",
    title: "PROYEK INDUSTRI",
    desc: "Lantai Pabrik Kimia | Pondasi Tangki | Area Pengolahan Limbah",
  },
  {
    image: "/assets/kuriamesh/Aplikasi_3.png",
    alt: "Marine",
    title: "KONSTRUKSI KELAUTAN & PESISIR",
    desc: "Dermaga | Pemecah Gelombang (Breakwater) | Dinding Laut | Dan Proyek Reklamasi",
  },
  {
    image: "/assets/kuriamesh/Aplikasi_4.png",
    alt: "Commercial",
    title: "BANGUNAN KOMERSIAL & INDUSTRIAL",
    desc: "Pelat Lantai | Dinding | Kolam Renang | Dan Area Basah Lainnya",
  },
];

const AppCard = ({ image, alt, title, desc }) => (
  <div className={styles.appCard}>
    <div className={styles.appCardImageContainer}>
      <img src={image} alt={alt} className={styles.appCardImage} />
      <Text className={styles.appCardTitle}>{title}</Text>
      <Text className={styles.appCardDesc}>{desc}</Text>
    </div>
  </div>
);

const KuriaMesh = () => {
  return (
    <Flex className={styles.container}>
      <Flex className={styles.headerContainer}>
        <video
          autoPlay
          loop
          muted
          playsInline
          poster="/assets/kuriamesh/temp-banner.png"
          className={styles.headerBg}
        >
          <source src="/assets/kuriamesh/Kuria_Mesh_Banner_Vid.mp4" type="video/mp4" />
        </video>
        <Flex className={styles.headerTextContainer}>
          <Text className={styles.headerTitleText}>KURIA</Text>
          <Text className={styles.headerTitleText}>MESH</Text>

          <Flex gap={{ base: 4, md: 8 }} paddingTop="32px">
            <Text className={styles.headerSubTitleText}>MUDAH </Text>
            <Text className={styles.headerSubTitleText}>.</Text>
            <Text className={styles.headerSubTitleText}>INSTAN</Text>
            <Text className={styles.headerSubTitleText}>.</Text>
            <Text className={styles.headerSubTitleText}>EFISIEN</Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex className={styles.infoSection}>
        <Text className={styles.infoText}>
          <a className={styles.infoText2}>KURIA MESH</a> adalah{" "}
          <a className={styles.infoText2}>tulangan beton </a> (wiremesh) yang
          dibuat dari batang komposit GFRP{" "}
          <span style={{ fontStyle: "italic" }}>
            (Glass Fiber Reinforced Polymer)
          </span>
          , dirancang sebagai alternatif superior pengganti wiremesh baja
          konvensional.
        </Text>
      </Flex>

      {/* Size Section  */}
      <Flex className={styles.sizeSection}>
        <img
          src="/assets/kuriamesh/size-banner.png"
          alt="Kuria Size banner"
          className={styles.sizeBg}
        />
        <Flex className={styles.sizeTextContainer}>
          <Text className={styles.sizeText}>
            Tersedia dalam <br />
            berbagai ukuran
          </Text>
          <img
            src="/assets/kuriamesh/size-chart.png"
            alt="Kuria Size Chart"
            className={styles.sizeChart}
          />
        </Flex>
      </Flex>

      {/* Prompt Section  */}
      <Flex className={styles.promptSection}>
        <img
          src="/assets/kuriamesh/prompt-banner.png"
          alt="Prompt Banner"
          className={styles.promptBg}
        />
        <Flex className={styles.promptTextContainer}>
          <Text className={styles.promptText}>Siap Pakai,</Text>
          <Text className={styles.promptText}>Pasang Lebih Cepat!</Text>
          <a
            href="https://wa.me/6285117255773"
            target="_blank"
            rel="noreferrer"
          >
            <Button
              className={styles.promptButton}
              bg="#ea2e01"
              color="white"
              _hover={{ bg: "#d42a00" }}
              size={{ base: "xs", md: "sm", lg: "lg" }}
              fontSize={{ base: "xs", md: "sm", lg: "lg" }}
            >
              PESAN SEKARANG
            </Button>
          </a>
        </Flex>
      </Flex>

      {/* Application Section  */}
      <Flex className={styles.applicationSection}>
        <Text className={styles.applicationHeader}>Aplikasi</Text>
        <div className={styles.applicationCarousel}>
          <Slider {...applicationSettings}>
            {applicationCards.map((card, index) => (
              <AppCard key={index} {...card} />
            ))}
          </Slider>
        </div>
      </Flex>

      {/* Callout Section */}
      <Flex className={styles.callOutBanner}>
        <Flex className={styles.callOutContent}>
          <Text className={styles.callOutText}>Tertarik Pakai Kuria?</Text>
          <a
            href="https://wa.me/6285117255773"
            target="_blank"
            rel="noreferrer"
          >
            <Box as="button" className={styles.callOutButton}>
              COBA KURIA SEKARANG
            </Box>
          </a>
        </Flex>
      </Flex>

      <Footer />
    </Flex>
  );
};

export default KuriaMesh;
